import { React, useState, useEffect, Fragment } from 'react'
import { Table, TableBody, Paper, Button, Grid, TableRow, TableCell, IconButton, Tooltip, TableHead, TableSortLabel,useMediaQuery,useTheme } from "@material-ui/core";
import { globalGetService, globalDeleteService, globalExportService } from '../../../utils/globalApiServices';
import { useSnackbar } from 'notistack';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { ConfgureTab, AddEditLLpTemp, ImportInventory } from '../components';
import { downloadFileType, checkApiStatus } from '../../../utils';
import { EmptyCollection, PageLoader, DeletePopUp, ExportMenu } from '../../../shared_elements';
import FilterComponent from '../../../shared_elements/components/filter_component';
import STableLoader from '../../../shared_elements/components/skeleton_loader/STableLoader';
import { LLPTempObj, LLPTempFilterOptions } from '.';
import { permissionCheckFnforCamo, } from '../../../utils';
import Pagination from '../../../shared_elements/components/Pagination';
import { trackActivity } from '../../../utils/mixpanel';
import AddIcon from '@material-ui/icons/Add';
import STabsLoader from '../../../shared_elements/components/skeleton_loader/STabsLoader';
const LLpTemplateHeader = ({ sortInfo, createSortHandler }) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell> Action(s) </TableCell>
                <TableCell><TableSortLabel active={sortInfo.sort === 'engine_family_id' ? true : false} direction={sortInfo.sort === 'engine_family_id' ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler('engine_family_id')} > Engine Family </TableSortLabel></TableCell>
                <TableCell><TableSortLabel active={sortInfo.sort === 'engine_type_id' ? true : false} direction={sortInfo.sort === 'engine_type_id' ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler('engine_type_id')} > Engine Type </TableSortLabel></TableCell>
                <TableCell><TableSortLabel active={sortInfo.sort === 'module_type' ? true : false} direction={sortInfo.sort === 'module_type' ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler('module_type')} > Module </TableSortLabel></TableCell>
                <TableCell><TableSortLabel active={sortInfo.sort === 'description' ? true : false} direction={sortInfo.sort === 'description' ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler('description')} > Description </TableSortLabel></TableCell>
                <TableCell><TableSortLabel active={sortInfo.sort === 'part_number' ? true : false} direction={sortInfo.sort === 'part_number' ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler('part_number')} > Part number </TableSortLabel></TableCell>
            </TableRow>
        </TableHead>
    )
}

const LLpTemplateList = ({ item, toggleModalFn, toggleDelteModalFn, onView }) => {
    return (
        <TableRow>
            <TableCell>
                <div style={{ gap: "3px", display: "inline-flex" }}>
                    <Tooltip title="View" arrow placement='top' >
                        <VisibilityIcon color='primary' style={{ fontSize: "1.35rem",cursor: 'pointer' }} onClick={onView} />
                    </Tooltip>
                    {permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" }) ? <Tooltip title="Edit" arrow placement='top'>
                        <CreateOutlinedIcon color='primary' onClick={toggleModalFn} style={{ fontSize: "1.35rem",cursor: 'pointer' }} />
                    </Tooltip> : null}
                    {permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "D" }) ? <Tooltip title="Delete" placement='top' arrow>
                        <DeleteOutlinedIcon onClick={toggleDelteModalFn} style={{ fontSize: "1.35rem",cursor: 'pointer' }} color='secondary' />
                    </Tooltip> : null}
                </div>
            </TableCell>
            <TableCell>{item?.engine_family_id?.name || '--'}</TableCell>
            <TableCell>{item?.engine_type_id?.name || '--'}</TableCell>
            <TableCell>{item?.module_type || '--'}</TableCell>
            <TableCell>{item?.description || '--'}</TableCell>
            <TableCell>{item?.part_number || '--'}</TableCell>
        </TableRow>
    )
}

function LlpTemplate({ match }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [filter, setFilter] = useState({});
    const [LLpTemplate, setLLpTemplate] = useState({ results: [], pagination: { page: 1, per_page: 250, total: 100 } });
    const [addEditLLpTemplate, setaddEditLLpTemplate] = useState({ modal: false, type: '', data: null });
    const [deleteLLpTemplate, setDeleteLLpTemplate] = useState({ modal: false, data: null });
    const [egineFamily, setEngineFamily] = useState([])

    useEffect(() => {
        getEngineFamily()
        getLLPTemplate({ ...filter, per_page: 250 }, 'skeletonLoader')
        trackActivity('LLP Template - Airworthiness Management', {
            event_type: 'Page Visited',
            page_title: 'LLP Template Tab from Configure Section'
        });
    }, [])

    const getEngineFamily = () => {
        globalGetService(`camo/engine_dropdown/`)
            .then((response) => {
                if (checkApiStatus(response)) {
                    setEngineFamily(response?.data?.data?.engine_family)
                }
            })
    }
    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getLLPTemplate({ ...filter, ...sortQuery, page: 1, per_page: LLpTemplate?.pagination?.per_page || 250 }, 'pageLoader');

    }

    const getLLPTemplate = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`camo/llp_part/2/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setLLpTemplate(response.data);
                    delete query.page
                    delete query.per_page
                    delete query.sort
                    delete query.sort_by
                    setFilter(query)
                    loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
                } else {
                    loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
                    enqueueSnackbar(response?.data?.message ? response?.data?.message : "something went wrong !", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
                }
            })
    }
    const onDeletellpTemplate = () => {
        setLoading(true);
        globalDeleteService(`camo/llp_part/2/${deleteLLpTemplate?.data?.id}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setLoading(false);
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    setDeleteLLpTemplate({ modal: false, data: null });
                    getLLPTemplate({ ...filter, per_page: LLpTemplate?.pagination?.per_page || 250 })
                    trackActivity('LLP Template Deleted - Airworthiness Management', {
                        event_type: 'LLP Template Deleted',
                        page_title: 'LLP Template Delete from Configure Section',
                        deleted_id: deleteLLpTemplate?.data?.id,
                        success_msg: response?.data?.message
                    })
                }
            })
    }
    const exportLlpTemp = (extension) => {
        setLoading(true);
        let queryParams = {}
        if (sortInfo?.sort === '' && sortInfo?.sort_by === '') {
            queryParams = Object.assign({}, filter);
        } else {
            queryParams = Object.assign({}, filter, sortInfo);
        }
        globalExportService(`camo/llp_part_number/2/export/`, { download: extension, ...queryParams })
            .then(response => {
                setLoading(false);
                downloadFileType(response?.data, 'LLP Template_Reports', extension)
                trackActivity('LLP Template Exported - Airworthiness Management', {
                    event_type: 'LLP Template Exported',
                    page_title: 'LLP Template Export from Configure Section',
                    file_name: 'LLP Template_Reports',
                    file_extension: extension,
                    success_msg: response?.data?.message
                })
            });
    }

    const filterObj = Object.assign({}, filter, delete filter.sort, delete filter.sortInfo)
    let filterOptions = Object.assign({}, LLPTempFilterOptions);
    filterOptions = {
        ...filterOptions,
        engine_family_id: {
            ...filterOptions.engine_family_id,
            options: egineFamily
        },
    }
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
    const tabsLoaderCount = window.innerWidth < 768 ? 3 : window.innerWidth < 1024 ? 5 : 9;
    return (
        <>
            <ConfgureTab tabIndex="llp" />
            <section className='camo-fleet-module'>
                {skeletonLoader ? <STabsLoader count={tabsLoaderCount} /> :
                    <Paper square elevation={2} variant='outlined' style={{ padding: '5px 10px' }}>
                        <Grid container spacing={1} alignItems='center'>
                            <Grid item md={8} sm={6} xs={12}>
                                <div style={{ marginTop: "2px" }}>
                                    <FilterComponent
                                        filter={filterObj}
                                        filterMenu={filterOptions}
                                        getResponseBack={(applyFilter) => getLLPTemplate({ ...applyFilter, page: 1, per_page: LLpTemplate?.pagination?.per_page || 20 }, 'pageLoader')}
                                    />
                                </div>
                            </Grid>
                            <Grid item md={4} sm={6} xs={12}>
                                <ul className='list-inline' style={{ float:"right",display:'flex' }}>
                                       <li className='list-inline-item'>
                                        <ExportMenu
                                            exportReportFn={(file) => exportLlpTemp(file.extension)}
                                            files={[{ title: 'EXCEL', extension: 'xlsx' }, { title: 'PDF', extension: 'pdf' }]}
                                            title='EXPORT'
                                        />
                                    </li>
                                        {permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "C" }) ? <li className='list-inline-item' style={{ marginInline: "10px" }}>
                                        <ImportInventory
                                            downloadSampleURL="camo/llp_part_number/2/sample/"
                                            importURl="camo/llp_part_number/2/import/"
                                            title="Import LLP Template"
                                            dsName='LLP Template'
                                            getResponseBack={() => getLLPTemplate({ ...filter, per_page: LLpTemplate?.pagination?.per_page || 250 }, 'pageLoader')}
                                        />
                                    </li> : null}
                                    {permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "C" }) ? <li className='list-inline-item' style={{ marginRight: "5px"}}>
                                        <Button onClick={() => setaddEditLLpTemplate({ modal: true, type: 'add', data: null })} color='primary' size="small" variant="contained"> <AddIcon style={{ fontSize: '1.15rem' }} /> {isMobile ? "ADD" : "ADD TEMPLATE"}</Button>
                                    </li> : null}
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>}
                {skeletonLoader ? <STableLoader count={tabsLoaderCount} /> :
                    <Paper variant='outlined' square style={{ marginBottom: "5px" }}>
                        <div style={{ height: !LLpTemplate?.results?.length ? 'auto' : `${window.innerHeight - 250}px`, overflow: 'auto' }}>
                            <Table className='mui-table-format' stickyHeader={true}>
                                <LLpTemplateHeader
                                    sortInfo={sortInfo}
                                    createSortHandler={createSortHandler}
                                />
                                {LLpTemplate?.results?.length > 0 && LLpTemplate?.results?.map((item, index) =>
                                    <TableBody>
                                        <LLpTemplateList
                                            item={item}
                                            toggleModalFn={() => setaddEditLLpTemplate({ modal: true, data: item, type: 'edit' })}
                                            toggleDelteModalFn={() => setDeleteLLpTemplate({ modal: true, data: item })}
                                            onView={() => { setaddEditLLpTemplate({ modal: true, type: 'view', data: item }); trackActivity('LLP Template View - Airworthiness Management', { event_type: 'View LLP template' }) }}
                                        />
                                    </TableBody>
                                )}
                            </Table>
                            {!LLpTemplate?.results?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                        </div>
                        <Pagination
                            pagination={LLpTemplate?.pagination}
                            onChangePage={(event, newPage) => getLLPTemplate({ ...filter, sort: sortInfo?.sort, sort_by: sortInfo?.sort_by, page: newPage + 1, per_page: LLpTemplate?.pagination?.per_page || 20 }, 'pageLoader')}
                            onChangeRowsPerPage={(event) => getLLPTemplate({ ...filter, page: 1, sort: sortInfo?.sort, sort_by: sortInfo?.sort_by, per_page: event.target.value }, 'pageLoader')}
                        />
                    </Paper>}
                {addEditLLpTemplate?.modal ?
                    <AddEditLLpTemp
                        llpdata={addEditLLpTemplate?.data}
                        modeType={addEditLLpTemplate?.type}
                        toggleModalFn={() => setaddEditLLpTemplate({ modal: false })}
                        getResponseBack={() => getLLPTemplate({ ...filter, per_page: addEditLLpTemplate?.pagination?.per_page || 250 }, 'pageLoader')}
                    /> : null
                }
                {deleteLLpTemplate.modal ?
                    <DeletePopUp
                        modal={deleteLLpTemplate.modal}
                        title='Delete LLP Template'
                        content={`Are you sure, you want to Delete?`}
                        toggleModalFn={() => setDeleteLLpTemplate({ modal: false, data: null })}
                        deleteRecordFn={onDeletellpTemplate}
                        extraNote={true}
                    /> : null
                }
                {isLoading ? <PageLoader /> : null}
            </section >
        </>
    )
}

export default withRouter(LlpTemplate)
